import React from 'react'
import {
  ManageCookies,
  InterestMarketingModal,
  DataAccessForm,
  DARHistory,
  DataCorrection,
  DataDeletion,
  PrivacyChoices,
  DataChoices,
  MarketingPreferences,
  SecurityOptions,
  PrivacyRights,
} from '../modals/index'

import Container from '../modals/common/container'

const Components = {
  manageCookies: ManageCookies,
  interestMarketingModal: InterestMarketingModal,
  dataRequestHistory: DARHistory,
  dataAccessRequest: DataAccessForm,
  dataCorrection: DataCorrection,
  dataDeletion: DataDeletion,
  privacyChoices: PrivacyChoices,
  privacyDataRights: DataChoices,
  marketingPreferences: MarketingPreferences,
  securityOptions: SecurityOptions,
  privacyRights: PrivacyRights,
}

const CreateComponent = (props) => {
  const { slides = [], position = 0 } = props

  const DynamicComponent = Components[props.name]

  if (!DynamicComponent && !slides.length) {
    return null
  }

  return slides.length ? (
    <Container position={position}>
      {slides.map((Slide, key) => (
        <Slide key={key} {...props} />
      ))}
    </Container>
  ) : (
    <DynamicComponent {...props} />
  )
}

export default CreateComponent
